<template>
	<div>
		<div class="hidden-xs-only">
			<div class="">
				<img src="../../assets/image/journalism/bg.png" class="width-100 h-500">
				<div class="fu h-500 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-57 c-white d-flex-center">新闻中心</div>
						<div class="f-28 c-white d-flex-center m-t-10">NEWS CENTER</div>
					</div>
				</div>
			</div>

			<div class="bgc-white d-flex-center h-80 d-flex-items-center">
				<div @click="choice(index)" v-for="(item,index) in tab" :key="index"
					class="w-115 h-40 lh-40 d-flex-center d-flex-items-center f-16"
					:class="nav==index?'c-white bgc-ec5e52':'c-00 bgc-white b-all-f0eeee'">
					{{item}}
				</div>
			</div>

			<div v-if="nav==0" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="width-80 p-b-40">
					<div @click="go(item.news_id)" v-for="(item,index) in info.news_list" :key="index"
						class="m-t-40 w-100p bgc-white p-20 p-l-30 p-r-30 d-flex-row">
						<img :src="item.smallimages" class="w-30p h-250" />
						<div class="m-l-30 w-70p">
							<div class="f-20 m-t-40 c-333333">{{item.title}}</div>
							<div class="m-t-25 d-flex-row">
								<div class="d-flex-row m-r-30">
									<img src="../../assets/image/journalism/z.png" class="m-r-20 w-16 h-16" />
									<span class="f-14 c-99">{{item.create_time}}</span>
								</div>
								<div class="d-flex-row">
									<img src="../../assets/image/journalism/y.png" class="m-r-20 w-22 h-16" />
									<span class="f-14 c-99">浏览次数：{{item.view_num}}</span>
								</div>
							</div>
							<div class="m-t-35 f-14 c-66">
								{{item.desc}}
								<!-- 2018年6月9日早八点半，长春市人才公寓“人才养成计划——人才课堂”第三期培训课程正式启动，为期两天的培训于6月10日圆满完成。来自中车长春轨道客车股份有限公司、吉林省红海人力资源服务有限公司、长春苏宁... -->
							</div>
						</div>
					</div>
					<div class="d-flex-center m-t-40">
						<el-pagination @current-change="next" background layout="prev, pager, next" :page-size="6"
							:total="info.news_total * 6">
						</el-pagination>
					</div>
				</div>
			</div>

			<div v-if="nav==1||nav==2" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="width-80 p-b-40 m-t-60">
					<div v-if="nav==1" class="f-26 c-00 font-weight-bold d-flex-center">通知公告</div>
					<div v-if="nav==2" class="f-26 c-00 font-weight-bold d-flex-center">入住须知</div>
					<div class="f-20 c-99 d-flex-center m-t-20">
						<span class="font-weight-bold">————</span>
						<span class="m-l-20 m-r-20">NOTICE</span>
						<span class="font-weight-bold">————</span>
					</div>
					<div class="d-flex-center d-flex-wrap">
						<div @click="go(item.news_id)" v-for="(item,index) in info.news_list" :key="index"
							:class="(index+1)%2==1? 'm-r-55':''" class="w-40p titlbox m-t-40">
							<img :src="item.smallimages" class="w-100p h-335" />
							<div class="h-50 lh-50 p-l-30 font-weight-bold">
								{{item.title}}
							</div>
						</div>
					</div>
					<div class="d-flex-center m-t-40">
						<el-pagination @current-change="next" background layout="prev, pager, next" :page-size="6"
							:total="info.news_total * 6">
						</el-pagination>
					</div>
					<!-- <div class="d-flex-center">
						<div class="b-all-c0c0c0 m-t-25 w-300 h-45 lh-45 d-flex-center c-2c598c font-weight-bold">
							查看更多
						</div>
					</div> -->
				</div>
			</div>

			<div v-if="nav==3" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="width-80 p-b-40 m-t-60">
					<div class="f-26 c-00 font-weight-bold d-flex-center">常见问题</div>
					<div class="f-20 c-99 d-flex-center m-t-20">
						<span class="font-weight-bold">————</span>
						<span class="m-l-20 m-r-20">COMMON PROBLEM</span>
						<span class="font-weight-bold">————</span>
					</div>

					<div class="d-flex-center">
						<div class="w-80p d-flex-row m-t-20 m-b-20">
							<div class="w-15p m-r-20 bgc-white">
								<div @click="choicel(index)" v-for="(item,index) in tablist" :key="index"
									:class="tablist.length!=(index+1)? 'b-b-F2EFEF':''"
									class="d-flex-row h-60 bgc-white">
									<div :class="navl==index? 'h-60 w-5 bgc-EA4638':'h-60 w-5'"></div>
									<div :class="navl==index? 'c-EA4638':'c-00'"
										class="f-18 width-100 d-flex-center d-flex-items-center">{{item}}</div>
								</div>
							</div>
							<div class="w-84p bgc-white">
								<div class="f-20 c-00 font-weight-bold b-b p-20 p-l-40 p-r-40">{{name}}</div>
								<div class="p-20 p-b-110">
									<div @click="touch(index)" v-for="(item,index) in info.news_list" :key="index"
										class="b-b-f7f6fb">
										<div class="d-flex-between d-flex-items-center h-75 lh-75">
											<div class="d-flex-row d-flex-items-center">
												<div class="w-38 h-36 b-b-ni c-white d-flex-center
												 d-flex-items-center f-16 p-r-5 m-r-40 m-t-8">Q{{index+1}}</div>
												<span
													class="f-16 c-33 font-weight-bold d-flex-items-center">{{item.title}}</span>
											</div>
											<i :class="item.state? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
										</div>
										<div v-if="item.state" class="p-20 bgc-f7f6fb f-16 lh-20">{{item.desc}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="hidden-sm-and-up">
			<div class="">
				<img src="../../assets/image/journalism/bg.png" class="width-100 h-300">
				<div class="fu1 h-300 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-30 c-white d-flex-center">新闻中心</div>
						<div class="f-14 c-white d-flex-center m-t-10">NEWS CENTER</div>
					</div>
				</div>
			</div>

			<div class="d-flex-center width-100 h-50 bgc-white">
				<div class="width-100 d-flex-around">
					<div @click="choice(index)" v-for="(item,index) in tab" :key="index">
						<div :class="nav==index? 'c-EA4638':''" class="h-46 d-flex-items-center font-weight-bold f-12">
							{{item}}
						</div>
						<div :class="nav==index? 'h-4 bgc-EA4638':''"></div>
					</div>
				</div>
			</div>

			<div v-if="nav==0" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="m-l-10 m-r-10 p-b-40 width-100">
					<div v-for="(item,index) in info.news_list" :key="index"
						class="width-100 m-t-10 bgc-white p-10 d-flex-row">
						<img :src="item.smallimages" class="w-140 h-120" />
						<div class="m-l-10">
							<div class="f-20 c-333333 overtext1">{{item.title}}</div>
							<div class="m-t-25 d-flex-row">
								<div class="d-flex-row m-r-10">
									<img src="../../assets/image/journalism/z.png" class="m-r-10 w-12 h-12" />
									<span class="f-10 c-99">{{item.create_time}}</span>
								</div>
								<div class="d-flex-row m-l-10">
									<img src="../../assets/image/journalism/y.png" class="m-r-10 w-15 h-12" />
									<span class="f-10 c-99">{{item.view_num}}</span>
								</div>
							</div>
							<div class="m-t-20 f-14 c-66 w-180 overtext">
								{{item.desc}}
								<!-- 2018年6月9日早八点半，长春市人才公寓“人才养成计划——人才课堂”第三期培训课程正式启动，为期两天的培训于6月10日圆满完成。来自中车长春轨道客车股份有限公司、吉林省红海人力资源服务有限公司、长春苏宁... -->
							</div>
						</div>
					</div>
					<div class="d-flex-center m-t-40">
						<el-pagination small :page-size="6" @current-change="next" layout="prev, pager, next"
							:total="info.news_total * 6">
						</el-pagination>
					</div>
				</div>
			</div>

			<div v-if="nav==1||nav==2" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="width-90 p-b-40 m-t-30">
					<div v-if="nav==1" class="f-26 c-00 font-weight-bold d-flex-center">通知公告</div>
					<div v-if="nav==2" class="f-26 c-00 font-weight-bold d-flex-center">入住须知</div>
					<div class="f-20 c-99 d-flex-center m-t-10">
						<span class="font-weight-bold">——</span>
						<span class="m-l-10 m-r-10">NOTICE</span>
						<span class="font-weight-bold">——</span>
					</div>
					<div class="d-flex-center d-flex-wrap">
						<div @click="go(item.news_id)" v-for="(item,index) in info.news_list" :key="index"
							class="w-100p titlbox m-t-20">
							<img :src="item.smallimages" class="w-100p h-200" />
							<div class="h-50 lh-50 p-l-10 p-r-10 font-weight-bold d-flex-center overtext">
								{{item.title}}
							</div>
						</div>
					</div>
					<div class="d-flex-center m-t-40 p-l-20 p-r-20">
						<el-pagination small :page-size="6" @current-change="next" layout="prev, pager, next"
							:total="info.news_total * 6">
						</el-pagination>
					</div>
				</div>
			</div>

			<div v-if="nav==3" class="width-100 bgc-f7f6fb d-flex-center">
				<div class="w-90p m-t-10 m-b-10">
					<div class="w-100p d-flex-between">
						<div @click="choicel(index)" v-for="(item,index) in tablist" :key="index"
							:class="navl==index? 'c-ec5e52':'c-00'" class="bgc-white f-12 p-5">
							{{item}}
						</div>
					</div>
					<div class="w-100p bgc-white m-t-10">
						<div class="p-10 p-b-50">
							<div @click="touch(index)" v-for="(item,index) in info.news_list" :key="index"
								class="b-b-f7f6fb">
								<div class="d-flex-between d-flex-items-center p-t-10 p-b-10">
									<div class="d-flex-row d-flex-items-center">
										<div class="w-28 h-26 b-b-ni1 c-white d-flex-center
												 d-flex-items-center f-12 m-r-10">Q{{index+1}}</div>
										<div class="w-85p f-14 c-33 font-weight-bold d-flex-items-center">
											{{item.title}}
										</div>
									</div>
									<i :class="item.state? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
								</div>
								<div v-if="item.state" class="p-10 bgc-f7f6fb f-12 lh-20">{{item.desc}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		list,
		problem
	} from './config/index.js'
	import {
		Loading
	} from 'element-ui';
	export default {
		data() {
			return {
				tab: ['通知公告', '园区新闻', '入住须知', '常见问题'],
				nav: 0,
				list: list,
				tablist: ['租房问题', '入住问题', '保洁问题', '退房问题', '配套服务'],
				navl: 0,
				name: "租房问题",
				problem: problem,
				info: {},
				page: 1
			}
		},
		mounted() {
			this.getinfo()
		},
		methods: {
			go(e) {
				this.$router.push({
					path: "/new-details",
					query: {
						news_id: e
					}
				});
			},
			next(e) {
				this.page = e
				this.getinfo()
			},
			async getinfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				let navl = ""
				if (this.nav != 3) {
					navl = this.navl + 1;
				}
				const res = await this.$service.post({
					url: '/api/web/v1/app_get_news',
					data: {
						type: this.nav + 1,
						category: navl,
						page: this.page
					}
				})
				if (res.code === 1) {
					if (this.nav == 3) {
						this.info = res.info;
						this.info.news_list = res.info.news_list.map((res) => {
							return {
								create_time: res.create_time,
								desc: res.desc,
								news_id: res.news_id,
								smallimages: res.smallimages,
								title: res.title,
								view_num: res.view_num,
								state: false
							}
						});
					} else {
						this.info = res.info;
					}
					if (res.info.news_list.length == 0) {
						this.$message.error("没有更多")
					}
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				}
			},
			choice(index) {
				this.nav = index;
				this.page = 1
				this.getinfo()
			},
			choicel(index) {
				this.navl = index;
				this.name = this.tablist[index];
				this.page = 1
				this.getinfo()
			},
			touch(index) {
				this.info.news_list[index].state = !this.info.news_list[index].state;
			}
		}
	}
</script>

<style scoped>
	.fu {
		position: relative;
		margin-top: -500px;
	}

	.fu1 {
		position: relative;
		margin-top: -300px;
	}

	.c-333333 {
		color: #333333;
	}

	.c-333333:hover {
		color: #ec5e52;
	}

	.titlbox {
		background: white;
		border: 1px solid #c0c0c0;
		color: #2c598c;
	}

	.titlbox:hover {
		background: #ec5e52;
		border: 1px solid #ec5e52;
		color: #FFF;
	}

	.titlbox:visited {
		background: #ec5e52;
		border: 1px solid #ec5e52;
		color: #FFF;
	}

	.overtext1 {
		width: 180px;
		white-space: nowrap;
		text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #ec5e52;
		color: #FFF;
	}

	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev,
	.el-pagination.is-background .el-pager li {
		background-color: #ffffff;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #ec5e52;
		color: #FFF;
	}

	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #ec5e52;
	}
</style>
